import { render } from "./PopUpNewTool.vue?vue&type=template&id=5caa9c4f"
import script from "./PopUpNewTool.vue?vue&type=script&lang=js"
export * from "./PopUpNewTool.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__